import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const COOKIE_NAME = 'pb-maintenance-bypass';

/* Forwards the maintenance-bypass cookie (set by /maintenance-bypass.html) to the API
** as a header, because the API lives on a different hostname and never receives the
** cookie itself. When maintenance is off the backend ignores the header entirely. */
@Injectable()
export class MaintenanceBypassInterceptor implements HttpInterceptor {

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token = this.readCookie(COOKIE_NAME);
		if (!token) {
			return next.handle(req);
		}
		return next.handle(req.clone({ setHeaders: { 'X-Maintenance-Bypass': token } }));
	}

	private readCookie(name: string): string | null {
		const entry = document.cookie.split('; ').find(c => c.startsWith(name + '='));
		return entry ? decodeURIComponent(entry.substring(name.length + 1)) : null;
	}
}
